module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn timing_kc"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), (this.checkForking.length > 0) ? _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', _vm._l((_vm.data), function(rows, i) {
    return _c('div', {
      staticClass: "card-block"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('div', {
      staticClass: "wrapper-title"
    }, [_c('tr', {
      staticClass: "main-tr"
    }, [_c('th', [_vm._v("Дата"), _c('br'), _vm._v(_vm._s(rows.date))])]), _vm._v(" "), _vm._m(0, true)])]), _vm._v(" "), _c('tbody', _vm._l((rows.data), function(row) {
      return _c('tr', {
        staticClass: "tr-data",
        style: (rows.time.indexOf(parseInt(row.local_period)) !== -1 ? 'background-color: rgb(200, 230, 201);' : '')
      }, [_c('td', {
        class: _vm.getClasses(row),
        style: (_vm.renderBackground(row))
      }, [_vm._v("\n                                        " + _vm._s(row.local_period) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.moscow_period) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.total) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.total_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.approved) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.approved_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.approved_accumulated_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.approvedFromValid(row.approved, row.total, row.spam)) + "\n                                    ")])])
    })), _vm._v(" "), _c('tfoot', {
      staticClass: "table-footer"
    }, [_c('tr', [_c('th', [_vm._v("Итого")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(rows.data.total_per_day))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s((rows.data.working_percent).toFixed(1)) + " %")])])])], 1)])
  }))])]) : _c('div', [_vm._v("Смены для этой страны не выставлены...")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titles"
  }, [_c('tr', [_c('th', [_vm._v("Часы(местное время)")]), _vm._v(" "), _c('th', [_vm._v("Часы (мск)")]), _vm._v(" "), _c('th', [_vm._v("Лиды")]), _vm._v(" "), _c('th', [_vm._v("% от общего")]), _vm._v(" "), _c('th', [_vm._v("Апрув лиды")]), _vm._v(" "), _c('th', [_vm._v("Апрув за час")]), _vm._v(" "), _c('th', [_vm._v("Апрув"), _c('br'), _vm._v("накопительный")]), _vm._v(" "), _c('th', [_vm._v("Апрув от валида")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ceaee202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/WorkTimingKC.vue
// module id = 594
// module chunks = 0